<template>
<div>

  <div v-if="editing">
    <edit-profile :logged-user="user"></edit-profile>
  </div>

  <div v-show="!editing" class="mdl-grid">
    <div class="mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp">
      <div class="ga-form-title">
        <h2 class="ga-title-text">{{'profile.label.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <div class="card-grid mdl-grid">

          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.status' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ 'profile.label.user.status.' + user.status.toUpperCase() || 'general.validation.required' | label }}
            </div>
          </div>

          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.nickname' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ user.nickname}}
            </div>
          </div>

          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.email' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ user.email }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.firstName' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ user.firstName}}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.lastName' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ user.lastName }}
            </div>
          </div>

          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.phone' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <span class="profile-text">
              {{ user.phone }}
            </span>
          </div>
          <div v-if="user.phone" id="testSms" class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.testSms' | label }}
            </div>
          </div>
          <div v-if="user.phone" class="mdl-cell mdl-cell--6-col">
            <test-sms></test-sms>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.timeZone' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ getLookup('TIME_ZONE', user.timeZone).label || 'general.validation.required' | label }}
            </div>
          </div>

          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.lastEmail' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              <span v-show="lastEmailSentOn">{{ lastEmailSentOn }}</span>
              <span v-show="!lastEmailSentOn">{{ 'profile.label.lastEmail.notSentYet' | label }}</span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.lastSMS' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              <span v-show="lastSMSSentOn">{{ lastSMSSentOn }}</span>
              <span v-show="!lastSMSSentOn">{{ 'profile.label.lastSMS.notSentYet' | label }}</span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.lastDelayConfirmation' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              <span v-show="lastDelayConfirmationDate">{{ lastDelayConfirmationDate }}</span>
              <span v-show="!lastDelayConfirmationDate">{{ 'profile.label.lastDelayConfirmation.notReceivedYet' | label }}</span>
            </div>
          </div>

          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.language' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-text">
              {{ getLookup('LANG', user.langCode).label || 'general.validation.required' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.subsription.status' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              <a v-link="{ path: '/app/sub' }">
                <!-- {{ 'profile.label.user.status.' + user.status || 'general.validation.required' | label }} -->
                {{ 'profile.label.user.status.' + user.subscription.status.toUpperCase() || 'general.validation.required' | label }}
              </a>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.label.mobile.download' | label }}
            </div>
          </div>
          <a v-on:click="comingSoon">
            <div class="badge playstore-badge"></div></a>
          <a v-on:click="comingSoon">
            <div class="badge appstore-badge"></div></a>
        </div>
      </div>
      <div class="mdl-card__menu profile-edit">
        <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
            v-on:click="edit()">
          <i class="material-icons">edit</i>
        </button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
var actions = require('common/store/actions')
var getters = require('common/store/getters')
var lookup = require('vue').filter('lookup')
var lookupValue = require('vue').filter('lookupValue')
var makeDate = require('vue').filter('makeDate')
var api = require('api')
var moment = require('moment-timezone')
var local = require('common/store/local')
module.exports = {
  ready: function () {
    // reload user data

    this.$dispatch('loading', true)
    api.User.profile({
      username: this.user.nickname
    }).then((result) => {
      this.setUser(result.data)
      return Promise.resolve()
    }).then(() => {
      // user not active yet
      if (this.user.status === 'PENDING') {
        this.$dispatch('loading', false)
        this.$router.replace('/app/userpending')
        return
      }
      if (this.user.subscription && this.user.subscription.status === 'Pending') {
        api.User.createPaymentUrl({id: this.user.id}).then((response) => {
          this.$router.replace('/app/payment/' + response.data.token)
        }).catch((err) => {
          this.$dispatch('show-error', err.data)
        })
        return
      }
      if (!this.user.hasMessageModel) {
        this.$dispatch('show-alert-message', 'profile.message.noMessageModel')
      } else if (!this.user.hasMessages) {
        this.$dispatch('show-alert-message', 'profile.message.noMessages')
      }
      this.$dispatch('loading', false)
    }).catch((err) => {
      this.$dispatch('loading', false)
      this.$dispatch('show-error', err.data)
    })
  },
  beforeDestroy: function () {
    this.$dispatch('dismiss-alert-message')
  },
  components: {
    editProfile: require('c/forms/ProfileEditForm'),
    testSms: require('c/forms/TestSmsForm')
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  methods: {
    edit: function () {
      this.editing = true
    },
    makeDate: function (date, timeZone, format) {
      return makeDate(date, timeZone, format)
    },
    getLookup: function (key, value) {
      return lookupValue(lookup(key), value)
    },
    onSuccess: function () {
      this.$dispatch('loading', false)
      this.$dispatch('show-success', 'profile.message.update.success')
      this.$emit('back')
    },
    onError: function (err) {
      this.$dispatch('show-error', err.data)
    },
    comingSoon: function () {
      this.$dispatch('show-error', {message: 'Coming soon'})
      return true
    }
  },
  events: {
    submitProfile: function (profile) {
      var self = this
      this.$dispatch('loading', true)
      api.User.update({id: this.user.id}, profile).then(function (result) {
        self.$dispatch('loading', false)
        var newLang = profile.langCode
        self.setUser(profile)
        if (newLang !== local.get('client.language')) {
          self.changeLanguage(newLang).then(function () {
            var split = location.href.split('?lang=')
            location.href = split[0] // + '?lang=' + newLang
//            self.$emit('back')
          })
        } else {
          self.$dispatch('show-success', 'profile.message.update.success')
          self.$emit('back')
        }
      }, this.onError)
    },
    submitPassword: function (password) {
      this.$dispatch('loading', true)
      api.User.updatePassword({id: this.user.id}, password).then(this.onSuccess, this.onError)
    },
    back: function () {
      this.editing = false
    }
  },
  data: function () {
    return {
      editing: false
    }
  },
  computed: {
    lastEmailSentOn: function () {
      if (this.user.lastEmail && this.user.lastEmail.sentOn) {
        this.offset = moment().tz(this.user['timeZone']).utcOffset()
        return moment.parseZone(this.user.lastEmail.sentOn).add(this.offset, 'minutes').locale(this.user.langCode).format('LLLL')
      } else return ''
    },
    lastSMSSentOn: function () {
      if (this.user.lastSMS && this.user.lastSMS.sentOn) {
        this.offset = moment().tz(this.user['timeZone']).utcOffset()
        return moment.parseZone(this.user.lastSMS.sentOn).add(this.offset, 'minutes').locale(this.user.langCode).format('LLLL')
      } else return ''
    },
    lastDelayConfirmationDate: function () {
      if (this.user.lastDelayConfirmation && this.user.lastDelayConfirmation.date) {
        this.offset = moment().tz(this.user['timeZone']).utcOffset()
        return moment.parseZone(this.user.lastDelayConfirmation.date).add(this.offset, 'minutes').locale(this.user.langCode).format('LLLL')
      } else return ''
    }
  }
}
</script>

<style scoped>
  .profile-edit {
    top: 0px;
  }
  .profile-edit .mdl-button.mdl-button--icon {
    font-size: 32px;
    width: 48px;
    height: 48px;
  }
  .profile-edit .mdl-button.mdl-button--icon .material-icons {
    color: #F19100;
    font-size: 32px;
    left: 20px;
    top: 24px;
  }
</style>



// WEBPACK FOOTER //
// Profile.vue?21087df0